module.exports = __webpack_public_path__ + "img/siniestro.566b785a.png";